import React from "react";
import { useStore } from "../../../store/useStore";
import { config } from "../../config";

export const Map = (props) => {
	const map = props.map;
	return (
		<a href={`${config.siteUrl}${map.src}`} target="_blank" rel="noreferrer">
			<img
				src={`${config.siteUrl}${map.src}`}
				alt={map.src}
				width={map.width}
				height={map.height}
				className="map-preview"
			/>
			<figure>{`${map.id} | ${map.width}x${map.height} ${map.src}`}</figure>
		</a>
	);
};

export default function Maps() {
	const { state } = useStore();

	console.log("Maps", state.maps);

	return (
		<div className="settings right-padding">
			<h1>Kartat sivustolta</h1>
			<p>Alla koottuna kaikki sivustolta tulevat kartat.</p>
			<ul>
				{state.maps &&
					state.maps.items &&
					state.maps.items.map((item) => (
						<li>
							<Map map={item} key={item.id} />
						</li>
					))}
			</ul>
		</div>
	);
}
